export default {
  name: 'tips-button',

  events: [
    {
      on: 'click',
      handle () {
        this.isOpen = !this.isOpen

        this.tipsPanel.classList.toggle('is-open')
        this.el.classList.toggle('is-open')

        if (this.isOpen) {
          clearTimeout(this.hideTimeout)
          this.el.classList.remove('is-hidden')
        }
      },
    },
  ],

  componentDidMount () {
    this.isOpen = false

    this.tipsPanel = document.querySelector('[js-tips]')
    setTimeout(() => {
      this.tipsPanel.classList.add('has-transition')
    }, 1000)

    document.addEventListener('mousemove', this.handleMouseMove)
  },

  componentWillUnmount () {
    document.removeEventListener('mousemove', this.handleMouseMove)
  },

  handleMouseMove (e) {
    if (!this.isOpen) {
      clearTimeout(this.hideTimeout)
      this.el.classList.remove('is-hidden')

      this.hideTimeout = setTimeout(() => {
        this.el.classList.add('is-hidden')
      }, 2000)
    }
  },
}
